import { appEnv } from '../env';
export function parsePrice(price, decimals) {
    var extendedPrice = price.padStart(decimals + 1, '0');
    var parsedPrice = "".concat(extendedPrice.slice(0, extendedPrice.length - decimals), ".").concat(extendedPrice.slice(-decimals));
    return Number.parseFloat(parsedPrice);
}
export function getImmutascanCtaUrl(tokenId) {
    return "https://immutascan.io/address/".concat(appEnv.blockchain.collectionAddress, "/").concat(tokenId || '');
}
export function getImmutascanTransactionUrl(id) {
    return "https://immutascan.io/tx/".concat(id);
}
export function getImmutascanWalletUrl(address) {
    return "https://immutascan.io/address/".concat(address);
}
export function getPolygonWalletUrl(address) {
    return "https://polygonscan.com/address/".concat(address);
}
